import axios from 'axios';
import Vue from 'vue';

const Sender = axios.create({
  baseURL: `${process.env.backUrl}/inside`,
  timeout: 25000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Accept-Language': Vue.prototype.$locale || 'ru',
  },
});

Sender.interceptors.request.use((async (request) => {
  return {
    ...request,
    headers: {
      ...request.headers,
      'Accept-Language': Vue.prototype.$locale || 'ru',
    },
  };
}));

export default Sender;